export const dateFormat = (d) => {
  const date = new Date(d);
  const getDate = date.getDate();
  const getMonth = (date.getMonth() + 1);
  return `${getMonth < 10 ? `0${getMonth}` : getMonth}/${getDate < 10 ? `0${getDate}` : getDate}/${date.getFullYear()}`;
};

export const getcurrentTime = (d) => {
  const date = new Date(d);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  const strTime = `${hours}:${minutes}:${seconds} ${ampm}`;
  return strTime;
};
